export default {
  PLAY: 'PLAY',
  STOP: 'STOP',
};
